/**
 *  USER ASK LOCATION
 *  -- returns a Promise with the user position :
 *  -- {
 *      latitude : x.xxx
 *      longitude : y.yyy
 *      timeout: date
 *  -- }
 */

import { i18n } from '@/commons/utils';

// When user ask location (~ long process)
// we save it for few minutes in localStorage
const LOCALSTORAGE_KEY = 'usr.position';
const LOCALSTORAGE_MINUTES = 30;

// Reference userPosition here for multiple / quick access
let userPosition = null;

export default () => {
  // Return directly if we have position
  if (userPosition) return Promise.resolve(userPosition);

  // Check for saved position
  const savedPosition = cube.storage.getObject(LOCALSTORAGE_KEY);
  if (
    savedPosition &&
    savedPosition.latitude &&
    savedPosition.longitude &&
    savedPosition.timeout > new Date().getTime()
  ) {
    userPosition = savedPosition;
    return Promise.resolve(savedPosition);
  }

  // Ask for navigator.geolocation
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      geoloc => {
        const position = {
          latitude: geoloc.coords.latitude,
          longitude: geoloc.coords.longitude,
          accuracy: geoloc.coords.accuracy,
          timeout: new Date().getTime() + 1000 * 60 * LOCALSTORAGE_MINUTES,
          name: i18n('geoloc.myposition'),
          isUserLocation: true,
        };
        userPosition = position;
        cube.storage.setObject(LOCALSTORAGE_KEY, position);
        resolve(position);
      },
      error => {
        console.warn('Error getting geolocation'); // eslint-disable-line no-console
        reject(error);
      }
    );
  });
};



// WEBPACK FOOTER //
// ./src/commons/user/ask-location.js